import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import { Profile } from 'data/training';
import { TableContainer, TableBody, TableRow, TableCell, Table, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TypeTitle, CompactAccordion } from './farm-profiles';

const NameCell = styled(TableCell)`
  display: flex;
  flex: 1;
  padding: 6px 16px;
  font-size: 13px;
  opacity: 0.75;
`;

type ProfilesTableProps = {
  profiles: Profile[];
  onPressRow: (profile: Profile) => void;
  title: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

const ProfilesTable: FunctionComponent<ProfilesTableProps> = ({
  profiles,
  onPressRow,
  title,
  expanded,
  onExpandedChange,
}) => {
  const [hoveredOverProfileId, setHoveredOverProfileId] = useState<string | undefined>(undefined);

  return (
    <CompactAccordion expanded={expanded} onChange={(_, isExpanded) => onExpandedChange(isExpanded)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ fontSize: 16 }} />}
        aria-controls="panel1c-content"
        style={{ minHeight: 24, padding: '0 8px' }}
      >
        <TypeTitle>{title}</TypeTitle>
      </AccordionSummary>
      <TableContainer style={{ display: 'flex', flex: 1 }}>
        <Table size="small" style={{ display: 'flex', flex: 1 }}>
          <TableBody style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            {profiles.map((profile) => (
              <TableRow
                key={profile.id}
                onClick={() => onPressRow(profile)}
                style={{
                  display: 'flex',
                  flex: 1,
                  ...(hoveredOverProfileId === profile.id
                    ? { backgroundColor: '#e7f0f6', cursor: 'pointer' }
                    : {}),
                }}
                onMouseEnter={() => setHoveredOverProfileId(profile.id)}
                onMouseLeave={() => setHoveredOverProfileId(undefined)}
              >
                <NameCell>{profile.name}</NameCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CompactAccordion>
  );
};

export default ProfilesTable;
